module.exports = __webpack_public_path__ + "static/media/cancelServiceDesktopIcon.fcb7f1c4.svg";